import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { setProgress, setToast } from "../../../redux/slice/system";
import { MainAPI } from "../../../axios/api";
import { useAbortedEffect, useSearch } from "../../../components/hooks";
import moment from "moment";

import {
  formatOptions,
  setPageSetting,
  cleanObj,
} from "../../../service/common";
import { system_dropdown, system_table } from "../../../service/system";
import {
  option_q_type,
  option_yesno,
  option_correct,
  option_5_score,
  option_education,
  option_parent,
  option_sex,
  option_treatment_type,
  option_treatment_type_less,
  option_treatment_undo,
  option_treatment_consider,
  option_treatment_correct,
  option_treatment_satisfaction,
  option_control_type,
  option_control_type_less,
  option_control_undo,
  option_control_consider,
  option_control_correct,
  option_control_satisfaction,
} from "../../../service/option";
import { generateFile } from "./setting";

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { BreadCrumb } from "primereact/breadcrumb";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Dropdown } from "primereact/dropdown";

export default function BackReportList(props) {
  const dispatch = useDispatch();
  const crumbItem = [{ label: "統計報表" }];
  const [reload, setReload] = useState({ list: false });
  // 列表資料
  const [apiData, setApiData] = useState([]);
  const [tbTotalRecords, setTbTotalRecords] = useState(0);
  const [tbFirstIndex, setTbFirstIndex] = useState(0);
  const [tbRows, setTbRows] = useState(system_table.size);
  // 篩選條件
  const defaultFilter = {
      type: null,
      page: 1,
    },
    pagePath = "/report";
  const {
    filterData,
    setFilterData,
    search,
    setSearch,
    changeFilter,
    renderSearchWrap,
  } = useSearch({
    defaultFilter,
    pagePath: [pagePath],
    tbSetting: { setTbFirstIndex, setTbRows },
    reloadAction: () => setReload((state) => ({ ...state, list: true })),
  });
  const [optionData, setOptionData] = useState({});
  const [checkData, setCheckData] = useState({ all: false });

  useEffect(() => {
    let temp = formatOptions({
      yesno: option_yesno,
      correct: option_correct,
      score_5: option_5_score,
      education: option_education,
      parent: option_parent,
      sex: option_sex,
      treatment_type: option_treatment_type,
      treatment_type_less: option_treatment_type_less,
      treatment_undo: option_treatment_undo,
      treatment_consider: option_treatment_consider,
      treatment_correct: option_treatment_correct,
      treatment_satisfaction: option_treatment_satisfaction,
      control_type: option_control_type,
      control_type_less: option_control_type_less,
      control_undo: option_control_undo,
      control_consider: option_control_consider,
      control_correct: option_control_correct,
      control_satisfaction: option_control_satisfaction,
    });

    setOptionData((state) => ({
      ...state,
      ...temp,
    }));
  }, []);

  // 表格頁數切換觸發
  const onPage = (e) => {
    const startIndex = e.first,
      rows = e.rows;

    // 同一頁面，不刷新
    if (startIndex === tbFirstIndex && rows === tbRows) {
      return;
    }

    setTbFirstIndex(startIndex);
    setTbRows(e.rows);

    let temp = {
      ...search,
      page: Math.floor(startIndex / e.rows) + 1,
      size: rows,
    };
    setFilterData(temp);
    setSearch(temp);
  };

  // 取得列表資料
  useAbortedEffect(
    (signal) => {
      if (!reload.list) {
        return;
      }

      dispatch(setProgress(true));

      setPageSetting({ params: search, page: pagePath });

      let params = {
        ...search,
      };
      params = cleanObj(params);

      MainAPI.getMainInfoList({ data: params, options: { signal } }).then(
        (result) => {
          let { Response, data, total, message } = result;

          if (Response === 1) {
            let tempCheck = { ...checkData };
            tempCheck.all = !data.some((item) => !tempCheck[item.id]);
            setCheckData(tempCheck);

            data.forEach((item) => {
              item.tyear_tmonth = `${item.tyear ? `${item.tyear}年` : ""}${
                item.tmonth ? `${item.tmonth}月` : ""
              }`;
            });

            setApiData(data);
            setTbTotalRecords(total);
            setReload((state) => ({
              ...state,
              list: false,
            }));
          } else {
            dispatch(
              setToast({
                severity: "error",
                summary: message,
                detail: "",
              })
            );
          }

          dispatch(setProgress(false));
        }
      );
    },
    [reload]
  );

  const getAllData = () => {
    dispatch(setProgress(true));

    let params = {
      ...search,
      page: -1,
    };

    MainAPI.getMainInfoList({ data: params }).then((result) => {
      let { Response, data, message } = result;

      if (Response === 1) {
        data.forEach((item) => {
          item.tyear_tmonth = `${item.tyear ? `${item.tyear}年` : ""}${
            item.tmonth ? `${item.tmonth}月` : ""
          }`;
        });
        exportFile({ type: "raw", data });
      } else {
        dispatch(
          setToast({
            severity: "error",
            summary: message,
            detail: "",
          })
        );
      }

      dispatch(setProgress(false));
    });
  };

  const exportFile = ({ type, data }) => {
    dispatch(setProgress(true));

    let tempCheck = { ...checkData };
    delete tempCheck.all;

    let reportData = type === "raw" ? [...data] : [...Object.values(tempCheck)];

    reportData = reportData.map((item) => {
      let raw = { ...item },
        question = { ...raw.questionnaire },
        member = { ...raw };
      delete member.questionnaire;

      let checkColumns = ["a1", "d1", "d2"];
      checkColumns.forEach((column) => {
        question[column] = question[column] ? question[column].split(",") : [];
      });

      return {
        member,
        question,
      };
    });

    if (reportData.length === 0) {
      dispatch(
        setToast({
          severity: "warn",
          summary: "請選擇匯出項目",
          detail: "",
        })
      );
      dispatch(setProgress(false));
      return;
    }

    generateFile({
      reportData,
      optionData,
      finishAction: () => dispatch(setProgress(false)),
    });
  };

  // 勾選比較項目
  const checkChange = (type, e, rowIndex) => {
    let tempCheck = { ...checkData };

    if (type === "all") {
      apiData.forEach((item) => {
        if (!e.checked) delete tempCheck[item.id];
        else tempCheck[item.id] = item;
      });

      tempCheck = { ...tempCheck, all: e.checked };
      setCheckData(tempCheck);
    } else if (type === "single") {
      if (!e.checked) delete tempCheck[apiData[rowIndex].id];
      else tempCheck[apiData[rowIndex].id] = apiData[rowIndex];

      let checkedAll = !apiData.some((item) => !tempCheck[item.id]);
      tempCheck = { ...tempCheck, all: checkedAll };
      setCheckData(tempCheck);
    }
  };

  return (
    <>
      <BreadCrumb
        className="border-none"
        model={crumbItem}
        home={{
          icon: "pi pi-home",
          command: () => {
            setFilterData(defaultFilter);
            setSearch(defaultFilter);
          },
        }}
      />

      <h2 className="my-4 ml-1">統計報表</h2>

      <div className="border-round-lg bg-white p-3">
        {renderSearchWrap({
          isShow: false,
          template: (
            <>
              <div className="col-12 md:col-4 xl:col-3 flex align-items-start flex-column mt-2 md:mt-0">
                <label
                  htmlFor="type"
                  className="w-4rem white-space-nowrap text-left mb-1"
                >
                  問卷類型
                </label>
                <Dropdown
                  name="type"
                  className="w-full"
                  value={filterData.type}
                  onChange={(e) => changeFilter(e)}
                  options={option_q_type}
                  optionLabel="label"
                  optionValue="value"
                  emptyFilterMessage={system_dropdown.emptyFilter}
                  showClear
                />
              </div>

              <div className="col-12 md:col-8 xl:col-9 flex align-items-end">
                <Button
                  className="p-button-main p-button-sm w-auto ml-auto md:ml-0 mt-2 md:mt-0 px-3"
                  type="button"
                  icon="pi pi-search"
                  label="查詢"
                  onClick={() => {
                    setSearch({ ...filterData, page: 1 });
                    setTbFirstIndex(0);
                    setCheckData({ all: false });
                  }}
                />
              </div>
            </>
          ),
        })}

        <div className="mt-2">
          <Button
            className="p-button-sm p-button-warning"
            type="button"
            label="勾選多筆匯出"
            onClick={() => exportFile({ type: "check" })}
          />
          <Button
            className="p-button-sm p-button-warning ml-2"
            type="button"
            label="全部匯出"
            onClick={() => getAllData()}
          />
        </div>

        <DataTable
          value={apiData}
          className="mt-1"
          size="small"
          paginator
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
          lazy
          first={tbFirstIndex}
          totalRecords={tbTotalRecords}
          onPage={onPage}
          rows={system_table.size}
          scrollable
          scrollDirection="both"
          emptyMessage={system_table.empty}
        >
          <Column
            field="campus"
            className="w-6rem"
            header={() => (
              <>
                <div className="flex align-items-center">
                  <Checkbox
                    className="mr-2"
                    value=""
                    onChange={(e) => checkChange("all", e, -1)}
                    checked={checkData.all}
                  ></Checkbox>
                  <label className="m-0">全選</label>
                </div>
              </>
            )}
            body={(data, { rowIndex }) => (
              <>
                <Checkbox
                  value=""
                  onChange={(e) =>
                    checkChange("single", e, rowIndex % system_table.size)
                  }
                  checked={checkData[data.id] ? true : false}
                ></Checkbox>
              </>
            )}
          ></Column>
          <Column
            field="email"
            header="信箱"
            className="flex-grow-1"
            style={{ flexBasis: "150px" }}
          ></Column>
          <Column
            field="psex"
            header="身分"
            className="flex-grow-1"
            style={{ flexBasis: "30px" }}
            body={(data) => <>{optionData.parent_obj[data.psex]?.showLabel}</>}
          ></Column>
          <Column
            field="edlevel"
            header="家長教育程度"
            className="flex-grow-1"
            style={{ flexBasis: "70px" }}
            body={(data) => (
              <>{optionData.education_obj[data.edlevel]?.showLabel}</>
            )}
          ></Column>
          <Column
            field="ksex"
            header="小孩性別"
            className="flex-grow-1"
            style={{ flexBasis: "30px" }}
            body={(data) => <>{optionData.sex_obj[data.ksex]?.showLabel}</>}
          ></Column>
          <Column
            field="birthday"
            header="小孩出生年"
            className="flex-grow-1"
            style={{ flexBasis: "60px" }}
            body={(data) => (
              <>{data.birthday ? moment(data.birthday).format("YYYY") : ""}</>
            )}
          ></Column>

          <Column
            field="id"
            header="進階"
            className="w-5rem froze-right"
            alignFrozen="right"
            frozen
            body={(data) => (
              <>
                <Button
                  className="p-button-sm p-button-warning"
                  type="button"
                  label="匯出"
                  onClick={() => exportFile({ type: "raw", data: [data] })}
                />
              </>
            )}
          ></Column>
        </DataTable>
      </div>
    </>
  );
}
